<template>
  <div class="text-center">
    <div
      :class="[
        'w-12 h-12 rounded-2xl flex items-center justify-center mx-auto mb-3',
        iconBgClass
      ]"
    >
      <svg
        :class="['w-6 h-6', iconColorClass]"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          :d="iconPath"
        />
      </svg>
    </div>
    <p class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">
      {{ label }}
    </p>
    <p class="text-2xl font-bold text-gray-900 dark:text-gray-100">
      {{ value }}
    </p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  label: string;
  value: string | number;
  iconPath: string;
  iconBgClass: string;
  iconColorClass: string;
}

defineProps<Props>();
</script>
